import React from 'react';
import BilanIconButton from './BilanIconButton';

interface AcceptedStatusButtonProps {
  onClick?: (
    ev:
      | React.MouseEvent<HTMLAnchorElement, MouseEvent>
      | React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => void;
}

export default function AcceptedStatusButton({ onClick }: AcceptedStatusButtonProps) {
  return (
    <BilanIconButton
      aria-label="Ouvrir le bilan accepté"
      iconType="tick_thick"
      onClick={onClick}
      size="xs"
      variantType="primary"
    />
  );
}
